let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jEsWt")).then(() => parcelRequire('g49IX'));